/// <amd-module name="TFS/Admin/Common/Controls/ListUsersAndManage/ListUsersAndManage" />
import React = require("react");

import { PersonaDetailsProvider } from "TFS/Admin/Common/Providers/PersonaDetailsProvider";

import { VssComponent } from "VSS/Platform/Layout";
import { IPersonaProvider, Persona, PersonaSize } from "VSSUI/Persona";

import { ICustomIdentityRef } from "TFS/Admin/Common/Contracts/CustomIdentityRef";
import Resources = require("TFS/Admin/Common/Controls/Resources");
import { UsersListDialog } from "TFS/Admin/Common/Controls/UsersListDialog/UsersListDialog";
import { IListUsersAndManageProps } from "TFS/Admin/Common/Controls/ListUsersAndManage/ListUsersAndManage.Props";
import { ObservableValue } from "VSS/Core/Observable";
import * as StringUtils from "VSS/Core/Util/String";
import { Button } from "VSSUI/Button";
import { IIdentity } from "VSSUI/IdentityPicker";
import { Observer } from "VSSUI/Observer";
import { Pill, PillSize } from "VSSUI/Pill";

export class ListUsersAndManage extends React.Component<IListUsersAndManageProps> {
    private personaProvider: IPersonaProvider;
    private maxDisplayCount: number;

    private _showListUsersDialog: ObservableValue<boolean> = new ObservableValue<boolean>(false);

    public constructor(props: IListUsersAndManageProps, context?: any) {
        super(props, context);

        this.personaProvider = new PersonaDetailsProvider(this.props.pageContext);
        this.maxDisplayCount = this.props.maxIdentitiesToDisplayCount || this.props.identities.length;
    }

    public render(): JSX.Element {
        return (
            <>
                <div className="entity-list">
                    <div className="entity-title">
                        <h2 className="title-m title">{this.props.title || Resources.Users}</h2>
                    </div>
                    {this.loadListPersonaElements()}
                    {this.props.identities && this.props.identities.length > this.maxDisplayCount && (
                        <div className="flex-row more-entities-pill">
                            <Pill
                                iconProps={{ iconName: "Add" }}
                                onClick={() => {
                                    this._showListUsersDialog.value = true;
                                }}
                                size={PillSize.regular}
                            >
                                <span className="more-entities-text">
                                    {StringUtils.format(Resources.MoreMembersLabel, this.props.identities.length - this.maxDisplayCount)}
                                </span>
                            </Pill>
                        </div>
                    )}
                    {this.props.identities && this.props.identities.length > 0 && <div className="empty-margin" />}
                    <div>
                        <Button disabled={!this.props.canAddMember} primary onClick={this.props.onAddMember!}>
                            {this.props.addButtonLabel || Resources.Add}
                        </Button>
                    </div>
                </div>

                <Observer showListUsersDialog={this._showListUsersDialog}>
                    {(props: { showListUsersDialog: boolean }) =>
                        props.showListUsersDialog && (
                            <UsersListDialog
                                users={this.props.identities.value}
                                title={this.props.title || Resources.Users}
                                onClose={() => {
                                    this._showListUsersDialog.value = false;
                                }}
                                canDeleteMember={this.props.canDeleteMember}
                                onDeleteMember={this.props.onDeleteMember}
                            />
                        )
                    }
                </Observer>
            </>
        );
    }

    private loadListPersonaElements() {
        const entityElementList = this.props.identities.value.slice(0, this.maxDisplayCount).map(entity => {
            const identity = this.castIdentityRefToIIdentity(entity); // Temporary workaround solution until web platform fixes Persona to accept IdentityRef
            return (
                <React.Fragment key={entity.descriptor}>
                    <div className="person-panel-row flex-row" aria-label={entity.displayName} data-is-focusable={true} key={entity.descriptor}>
                        <Persona size={PersonaSize.size40} identity={identity} personaProvider={this.personaProvider} />
                        <div className="flex-column">
                            <label className="persona-title">{entity.displayName}</label>
                            <label className="persona-secondary-title">{entity.preferredEmailAddress}</label>
                        </div>
                        {this.props.canDeleteMember && (
                            <Button
                                className="delete-button"
                                subtle={true}
                                iconProps={{ iconName: "Delete" }}
                                onClick={() => this.props.onDeleteMember!(entity)}
                            />
                        )}
                    </div>
                </React.Fragment>
            );
        });

        return entityElementList;
    }

    private castIdentityRefToIIdentity(identity: ICustomIdentityRef): IIdentity {
        const newIdentity: IIdentity = {} as IIdentity;

        newIdentity.localId = identity.id;
        newIdentity.displayName = identity.displayName;
        newIdentity.image = identity.imageUrl;
        newIdentity.mail = identity.preferredEmailAddress;
        newIdentity.subjectDescriptor = identity.descriptor;

        return newIdentity;
    }
}

VssComponent.register("ms.vss-admin-web.list-users-and-manage-component", ListUsersAndManage);
